export default __webpack_public_path__ + "static/Nuts-63b0534a4fbb02cefc1af8e84cfab23b.jpg";